import React, { Component } from "react";
import {
    View, Image, TouchableOpacity, Animated,
    StyleSheet,
    Dimensions, ScrollView
} from 'react-native'
import LinearGradient from 'react-native-linear-gradient';
import { blueDarkColor, blueLightColor } from "../theme/colors";
import { loginStyles, appStyles } from "../theme/styles";
import TextView from "../components/TextView";
import Button from "../components/Button";
import { icons } from "../theme/icons";
import GradiantWraper from "../components/GradiantWraper";
import { signupRequest, loginRequest, activationRequest, rulesRequest } from "../utils/api";
import {getUser, createUser, setToken} from "../database/UserDal";
import Waiting from "../components/Waiting";
import { persianNumber, getError } from "../utils/utils";
import { hp, wp } from "../utils/responsive";
import DialogMessage from "../components/DialogMessage";
import TextInput from "../components/TextInput/TextInput";
import WebView from "react-native-webview";
const regexnonenglishdigit = /[a-z]|[A-Z]|[0-9]|[۱۲۳۴۵۶۷۸۹۰]/g;
const styles = StyleSheet.create({
    a: {
        fontWeight: '300',
        color: '#FF3366'
    },
    p: {
        lineHeight: hp(4),
        margin: 10,
        fontFamily: 'IRANSansMobile',

        textAlign: 'right',
    }
});
var { height } = Dimensions.get('window');
var theme = {
    colors: {
        text: 'black',
        error: 'red',
        primary: '#000000cc',
        outlineColor: '#eeeeee',
        placeholder: 'gray'
    }
}
export default class LoginScreen extends Component {
    intervalId = 0;
    constructor(props) {
        super(props)

        this.state = {
            ruleModal: false,
            acceptRule: false,
            rules: '',
            expanded: false,
            waiting: false,
            animation: new Animated.Value(0),
            minHeight: 150,
            maxHeight: height - 250,
            step: 0,
            secend: 60,
            fname: '',
            lname: '',
            mobile: '',
            activeCode: '',
            ncode: '',
            codemoaref: '',
            showMessage: false,
            messageTitle: '',
            messageContent: '',
            messageSuccess: false
        }
        this.inputs = {};

    }

    toggle() {
        let initialValue = this.state.expanded ? this.state.maxHeight + this.state.minHeight : this.state.minHeight,
            finalValue = this.state.expanded ? this.state.minHeight : this.state.maxHeight + this.state.minHeight;
        this.setState({
            expanded: !this.state.expanded
        });
        this.state.animation.setValue(initialValue);
        Animated.spring(
            this.state.animation,
            {
                toValue: finalValue
            }
        ).start();
    }
    getTitle(step) {
        if (step === 0) {
            return 'ورود به آد';
        } else if (step === 1) {
            return 'ثبت نام در آد';
        } else if (step === 2) {
            return 'فعال سازی اکانت';
        }
    }
    focusTheField = (prev, next) => {
        this.inputs[prev].blur()

        this.inputs[next].focus();
    }
    render() {
        return (
            <View style={{ flex: 1 }}>
                <LinearGradient colors={[blueDarkColor, blueLightColor]} style={loginStyles.container}>
                    {this.state.expanded ? <View style={appStyles.rowBetween}>
                        <Image source={icons['ad_logo']} style={appStyles.adLogo} />
                        <TextView style={appStyles.screenTitle}>{this.getTitle(this.state.step)}</TextView>
                    </View> : null}
                    {!this.state.expanded ? <View style={loginStyles.center}>
                        <Image source={icons['splash']} style={loginStyles.image} />
                    </View> : null}
                    <Animated.View style={[appStyles.bottomView, { height: this.state.animation, minHeight: hp(20) }]}>
                        <ScrollView enableOnAndroid={true} keyboardShouldPersistTaps='handled'>
                            {this.state.expanded ? <View style={loginStyles.wraper}>
                                <TouchableOpacity onPress={() => {
                                    this.toggle()
                                }}>
                                    <Image source={icons['dropdown']} style={appStyles.dropdown} />
                                </TouchableOpacity>
                                {this.state.step === 1 ? <View style={{ width: wp(100), flex: 1 }}>
                                    <GradiantWraper style={loginStyles.circleWraper}>
                                        <Image source={icons['add_person']} style={loginStyles.icon} />
                                    </GradiantWraper>
                                    <TextInput
                                        label='نام'
                                        mode='outlined'
                                        theme={theme}
                                        ref={input => { this.inputs['fname'] = input }}
                                        returnKeyType={'next'}
                                        onSubmitEditing={() => { this.focusTheField('fname', 'lname') }}
                                        wrapperStyle={{ width: wp(90) }}
                                        onChangeText={(text) => {
                                            this.setState({
                                                fname: text.replace(regexnonenglishdigit, '')
                                            })
                                        }}
                                        value={this.state.fname}
                                    />
                                    <TextInput
                                        label='نام خانوادگی'
                                        mode='outlined'
                                        theme={theme}
                                        ref={input => { this.inputs['lname'] = input }}
                                        returnKeyType={'next'}
                                        onSubmitEditing={() => { this.focusTheField('lname', 'mobile') }}
                                        wrapperStyle={{ width: wp(90) }}
                                        onChangeText={(text) => {
                                            this.setState({
                                                lname: text.replace(regexnonenglishdigit, '')
                                            })
                                        }}
                                        value={this.state.lname}
                                    />
                                    <TextInput
                                        label='شماره موبایل'
                                        mode='outlined'
                                        theme={theme}
                                        maxLength={11}
                                        ref={input => { this.inputs['mobile'] = input }}
                                        returnKeyType={'next'}
                                        onSubmitEditing={() => { this.focusTheField('mobile', 'codemeli') }}
                                        wrapperStyle={{ width: wp(90) }}
                                        inputType='numeric'
                                        onChangeText={(text) => {
                                            this.setState({
                                                mobile: text
                                            })
                                        }}
                                        value={this.state.mobile}
                                    />
                                    <TextInput
                                        label='کدملی'
                                        mode='outlined'
                                        theme={theme}
                                        maxLength={10}
                                        inputType='numeric'
                                        ref={input => { this.inputs['codemeli'] = input }}
                                        returnKeyType={'next'}
                                        onSubmitEditing={() => { this.focusTheField('codemeli', 'codemoaref') }}
                                        wrapperStyle={{ width: wp(90) }}
                                        onChangeText={(text) => {
                                            this.setState({
                                                ncode: text
                                            })
                                        }}
                                        value={this.state.ncode}
                                    />
                                    <TextInput
                                        label='کد معرف آد'
                                        mode='outlined'
                                        theme={theme}
                                        ref={input => { this.inputs['codemoaref'] = input }}
                                        returnKeyType={'done'}
                                        onSubmitEditing={() => {

                                        }}
                                        wrapperStyle={{ width: wp(90) }}
                                        onChangeText={(text) => {
                                            this.setState({
                                                codemoaref: text
                                            })
                                        }}
                                        value={this.state.codemoaref}
                                    />
                                    <Button
                                        text='ثبت نام'
                                        style={{ width: wp(50), marginTop: 20, alignSelf: 'center', minHeight: hp(6) }}
                                        textStyle={loginStyles.buttonText}
                                        onPress={() => {
                                            if (this.state.fname.length > 0 && this.state.lname.length > 0) {
                                                if (this.state.ncode.length === 10) {
                                                    if (this.state.mobile.length === 11) {
                                                        this.setState({
                                                            waiting: true
                                                        })
                                                        signupRequest(this.state.mobile, this.state.fname, this.state.lname, this.state.ncode,
                                                            this.state.codemoaref, (isConnect, response) => {
                                                                this.setState({
                                                                    waiting: false
                                                                })
                                                                if (isConnect && response.isSuccess) {
                                                                    createUser(this.state.mobile );
                                                                    setToken(response.data.token)
                                                                    this.setState({
                                                                        step: 2,
                                                                        secend: 60,
                                                                    }, () => {
                                                                        this.setTimer()
                                                                    })
                                                                } else {
                                                                    this.setState({
                                                                        showMessage: true,
                                                                        isSuccess: false,
                                                                        messageContent: getError(response)
                                                                    })
                                                                }
                                                            })
                                                    } else {
                                                        this.setState({
                                                            showMessage: true,
                                                            isSuccess: false,
                                                            messageContent: "شماره موبایل صحیح نمی باشد"
                                                        })
                                                    }
                                                } else {
                                                    this.setState({
                                                        showMessage: true,
                                                        isSuccess: false,
                                                        messageContent: "کد ملی صحیح نمی باشد"
                                                    })
                                                }
                                            } else {
                                                this.setState({
                                                    showMessage: true,
                                                    isSuccess: false,
                                                    messageContent: "نام و نام خانوادگی خود را وارد نمایید"
                                                })
                                            }
                                        }}
                                    />
                                    <TouchableOpacity style={{ margin: 15, padding: 5 }} onPress={() => {
                                        this.setState({
                                            step: 0
                                        })
                                    }}>
                                        <TextView style={loginStyles.text}>اگر قبلا ثبت نام کرده اید وارد شوید</TextView>
                                    </TouchableOpacity>
                                </View> : null}
                                {this.state.step === 0 ? <View>
                                    <GradiantWraper style={loginStyles.circleWraper}>
                                        <Image source={icons['keypass']} style={loginStyles.icon} />
                                    </GradiantWraper>
                                    <TextView style={[loginStyles.text, { margin: 20 }]}>شماره همراه خود را برای دریافت کدفعالسازی وارد نمایید</TextView>
                                    <TextInput
                                        label='شماره موبایل'
                                        inputType='numeric'
                                        mode='outlined'
                                        theme={theme}
                                        returnKeyType={'done'}
                                        onSubmitEditing={() => {

                                        }}
                                        wrapperStyle={{ width: wp(90) }}
                                        onChangeText={(text) => {
                                            this.setState({
                                                mobile: text
                                            })
                                        }}
                                        value={this.state.mobile}
                                    />
                                    <Button
                                        text='ارسال کد فعالسازی'
                                        style={{ width: wp(50), marginTop: 20, alignSelf: 'center' }}
                                        textStyle={[loginStyles.buttonText]}
                                        onPress={() => {
                                            if (this.state.mobile.length === 11) {
                                                this.setState({
                                                    waiting: true
                                                })
                                                loginRequest(this.state.mobile, (isConnect, response) => {
                                                    this.setState({
                                                        waiting: false
                                                    })
                                                    if (isConnect && response.isSuccess) {
                                                        setToken(response.data.token);
                                                        createUser(this.state.mobile)

                                                        this.setState({
                                                            step: 2,
                                                            secend: 60
                                                        }, () => {
                                                            this.setTimer();
                                                        })

                                                    } else {
                                                        this.setState({
                                                            showMessage: true,
                                                            isSuccess: false,
                                                            messageContent: getError(response)
                                                        })
                                                    }
                                                })
                                            } else {
                                                this.setState({
                                                    showMessage: true,
                                                    isSuccess: false,
                                                    messageContent: "شماره موبایل صحیح نمی باشد"
                                                })
                                            }

                                        }}
                                    />
                                    <TouchableOpacity style={{ margin: 15, padding: 5 }} onPress={() => {
                                        this.setState({
                                            step: 1,
                                            ruleModal: !this.state.acceptRule
                                        })

                                    }}>
                                        <TextView style={loginStyles.text}>تاکنون ثبت نام نکرده ام</TextView>
                                    </TouchableOpacity>
                                </View> : null}
                                {this.state.step === 2 ? <View>
                                    <GradiantWraper style={loginStyles.circleWraper}>
                                        <Image source={icons['messagephone']} style={loginStyles.icon} />
                                    </GradiantWraper>
                                    <TextView style={[loginStyles.text, { margin: 20 }]}>کد فعالسازی را وارد نمایید</TextView>
                                    <TextInput
                                        placeholder='کد فعالسازی'
                                        inputType='numeric'
                                        mode='outlined'
                                        theme={theme}
                                        returnKeyType={'done'}
                                        onSubmitEditing={() => {

                                        }}
                                        wrapperStyle={{ width: wp(90) }}
                                        onChangeText={(text) => {
                                            this.setState({
                                                activeCode: text
                                            })
                                        }}
                                        value={this.state.activeCode}
                                    />
                                    <Button
                                        text='تایید کد فعالسازی'
                                        style={{ width: wp(50), marginTop: 20, alignSelf: 'center', height: hp(6) }}
                                        textStyle={loginStyles.buttonText}
                                        onPress={() => {
                                            if (this.state.activeCode.length === 4) {
                                                this.setState({
                                                    waiting: true
                                                })
                                                activationRequest(this.state.activeCode, (isConnect, response) => {
                                                    this.setState({
                                                        waiting: false
                                                    })
                                                    if (isConnect && response.isSuccess) {
                                                        response.data['status'] = 2;
                                                        createUser(response.data)
                                                        this.props.navigation.navigate('main')
                                                    } else {
                                                        this.setState({
                                                            showMessage: true,
                                                            isSuccess: false,
                                                            messageContent: getError(response)
                                                        })
                                                    }
                                                })
                                            } else {
                                                this.setState({
                                                    showMessage: true,
                                                    isSuccess: false,
                                                    messageContent: 'کد فعالسازی صحیح نمی باشد'
                                                })
                                            }

                                        }}
                                    />
                                    <TouchableOpacity style={{ margin: 15, padding: 5 }} onPress={() => {
                                        if (this.state.secend === 0) {
                                            this.setState({
                                                waiting: true
                                            })
                                            loginRequest(this.state.mobile, (isConnect, response) => {
                                                this.setState({
                                                    waiting: false,
                                                })
                                                if (isConnect && response.isSuccess) {
                                                    createUser(this.state.mobile )
                                                    setToken(response.data.token)
                                                    this.setState({
                                                        step: 2,
                                                        secend: 60
                                                    }, () => {
                                                        this.setTimer()
                                                    })

                                                } else {
                                                    this.setState({
                                                        showMessage: true,
                                                        isSuccess: false,
                                                        messageContent: getError(response)
                                                    })
                                                }
                                            })
                                        }
                                    }}>
                                        {this.state.secend > 0 ? <TextView style={loginStyles.text}>اعتبار کد تا {persianNumber(this.state.secend)} ثانیه</TextView> :
                                            <TextView style={{ textAlign: 'center' }}>ارسال مجدد کد فعالسازی</TextView>}
                                    </TouchableOpacity>
                                </View> : null}
                                <View />
                            </View> : null}
                            {!this.state.expanded ? <View style={loginStyles.wraper}>
                                <TextView style={loginStyles.text}>اگر قبلا ثبت نام کرده اید وارد شوید</TextView>
                                <View style={[appStyles.row, { marginBottom: 20, marginTop: 10 }]}>
                                    <Button
                                        text='ثبت نام'
                                        style={{ minWidth: wp(40), minHeight: hp(6) }}
                                        textStyle={loginStyles.buttonText}
                                        onPress={() => {
                                            this.setState({
                                                step: 1,
                                                ruleModal: !this.state.acceptRule
                                            })
                                            this.toggle()
                                        }}
                                    />
                                    <TouchableOpacity activeOpacity={0.5} style={loginStyles.button} onPress={() => {
                                        this.setState({
                                            step: 0
                                        })
                                        this.toggle()
                                    }}>
                                        <TextView style={loginStyles.text}>ورود</TextView>
                                    </TouchableOpacity>
                                </View>
                            </View> : null}
                        </ScrollView>
                    </Animated.View>
                    <Waiting waiting={this.state.waiting} />
                    <DialogMessage
                        show={this.state.showMessage}
                        title={this.state.messageTitle}
                        message={this.state.messageContent}
                        onClose={() => {
                            this.setState({
                                showMessage: false
                            })

                        }} />
                </LinearGradient>
                {this.state.ruleModal?<View style={appStyles.modalMessageAbsolute} >

                        <View style={appStyles.modalSearchContent}>
                            <View style={[appStyles.toolbarWraper, { borderBottomColor: '#eeeeee', borderBottomWidth: 1 }]}>
                                <View style={appStyles.backIcon} />
                                <TextView>قوانین و مقررات</TextView>
                            </View>

                                <WebView
                                    containerStyle={{width:wp(100),height:hp(95)}}
                                    source={{html: this.state.rules}}
                                />

                            <View style={[appStyles.rowAround, { marginTop: 20, marginBottom: 20 }]}>
                                <TouchableOpacity style={[appStyles.outlineButton, {
                                    height: hp(6), borderRadius: hp(6) / 2,
                                    width: wp(20), minWidth: wp(40), alignSelf: 'center'
                                }]} onPress={() => {
                                    this.setState({
                                        step: 0,
                                        ruleModal: false,
                                    })
                                    this.toggle()
                                }}>
                                    <TextView style={{ color: '#C0C0C0', textAlign: 'center' }}>{'نمی پذیرم'}</TextView>
                                </TouchableOpacity>
                                <Button
                                    text={'می پذیرم'}
                                    style={{ paddingLeft: 20, paddingRight: 20, height: hp(6), borderRadius: hp(6) / 2, width: wp(40), marginLeft: 20 }}
                                    textStyle={[loginStyles.buttonText, { fontSize: 14 }]}
                                    onPress={() => {
                                        this.setState({
                                            ruleModal: false,
                                            acceptRule: true
                                        })
                                    }}
                                />

                            </View>
                        </View>
                    </View>:null}
            </View>)
    }

    setTimer() {

        this.intervalId = setInterval(() => {
            if (this.state.secend > 0) {
                this.setState({
                    secend: this.state.secend - 1
                })
            } else {
                clearInterval(this.intervalId);
            }

        }, 1000)
    }


    componentWillMount() {
        var user = getUser();
        if (user != null && user.ncode != null && user.ncode.length > 0) {
            this.props.navigation.navigate('main')
        }
        rulesRequest((isConnect, response) => {
            if (isConnect && response.isSuccess) {
                this.setState({
                    rules: response.data.rules
                })
            }
        })
    }

}
